


























import { Component, Vue } from "vue-property-decorator";
import { Fragment } from "vue-fragment";
import { DataProgress, ReportStep } from "@/models/graphql-global-types";
import { NewReportStore } from "@/store/NewReportStore";
import { ReportFilterStore } from "@/store/ReportFilterStore";
import { UserService } from "@/services/UserService";
import { ReportOverview } from "@/models/queries/ReportOverviewQuery";
import { mapState, mapActions } from "vuex";
import ReportButtonBar from "@/components/reports/partials/report-button-bar.vue";

@Component({
  props: {
    step: String
  },
  components: {
    ReportButtonBar,
    Fragment
  }
})
export default class ReportDashboardView extends Vue {
  private ReportStep = ReportStep;
  private DataProgress = DataProgress;
  private isUserAdmin = UserService.isUserAdmin;
  private isUserTester = UserService.isUserTester;
  private isUserViewer = UserService.isUserViewer;
  private isUserSupervisor = UserService.isUserSupervisor;
  private deletedReports: ReportOverview[] = [];

  get loading() {
    return NewReportStore.loading;
  }
  get initialLoadDone() {
    return NewReportStore.initialLoadDone;
  }
  get selectedSteps() {
    return ReportFilterStore.reportSteps;
  }

  get allReports() {
    return NewReportStore.reports;
  }

  get filteredReports() {
    return ReportFilterStore.filteredReports;
  }

  public isUserOwnerOfReport(report: ReportOverview) {
    return UserService.isUserOwnerOfReport(report);
  }
}
